export const PageDataState = {
    Searchs: {
        external_user_id: {
            type: 'text',
            id: 'external_user_id',
            label: '',
            value: '',
        },
        enterprise: {
            type: 'text',
            id: 'enterprise',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            placeholder: 'ตำแหน่ง',
        },
        work_status: {
            type: 'select',
            id: 'work_status',
            label: 'การทำงาน',
            value: '',
        },
        work_history_status: {
            type: 'select',
            id: 'work_history_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        external_user_id: {
            type: 'select',
            id: 'external_user_id',
            label: 'ผู้ใช้งานภายนอก',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        enterprise: {
            type: 'text',
            id: 'enterprise',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '5',
            id: 'description',
            label: 'รายละเอียดการทำงาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        salary: {
            type: 'text',
            id: 'salary',
            label: 'เงินเดือน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 6000,
                max: 200000
            },
            error: { status: null, msg: '' }
        },
        job_description: {
            type: 'file',
            id: 'job_description',
            label: 'เอกสารแนบ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },            
            error: { status: null, msg: '' }
        },
        start_date: {
            type: 'text',
            id: 'start_date',
            label: 'วันที่เริ่มงาน',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        end_date: {
            type: 'text',
            id: 'end_date',
            label: 'ถึง',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        work_status: {
            type: 'select',
            id: 'work_status',
            label: 'การทำงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {}
}